/* @ngInject */
function EntryController ($scope, $translate, $state, $location, UdsModalService, AuthService) {
  const getGuestLoginDialogController = () => import('../../dialogs/guest-login/guest-login-dialog.controller')
  const getGuestResendPasswordDialogController = () => import('../../dialogs/guest-resend-password/guest-resend-password-dialog.controller')

  const api = {
    _checkOpeningType,
    _getCustomerLogo,
    _openLoginDialog,
    _openResendPasswordDialog
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._checkOpeningType()
  }

  function _checkOpeningType () {
    $scope.type = $state.current.data.type

    switch ($scope.type) {
      case 'LOGIN': api._openLoginDialog(); break
      case 'RESEND_PASSWORD': api._openResendPasswordDialog(); break
      case 'BRIEFING_SUMMARY': $scope.briefingId = $state.params.briefingId; break
      case 'APPROVAL_SUMMARY': $scope.approvalId = $state.params.approvalId; break
      case 'ASSET_PACK_DOWNLOAD_ALL_SUMMARY':
        $scope.assetPackId = $state.params.assetPackId
        break
      case 'ASSET_PACK_SUMMARY':
        $scope.assetPackId = $state.params.assetPackId
        $scope.assetFolderId = $state.params.assetFolderId
        break
    }

    if ($scope.type === 'LOGIN' || $scope.type === 'RESEND_PASSWORD') {
      api._getCustomerLogo()
    }
  }

  function _openLoginDialog () {
    getGuestLoginDialogController().then(({ GuestLoginDialogController }) => {
      const guestLoginDialog = UdsModalService.createModal({
        controller: GuestLoginDialogController,
        modalName: 'guestLoginDialog',
        data: {}
      })

      guestLoginDialog.open()
    })
  }

  function _openResendPasswordDialog () {
    getGuestResendPasswordDialogController().then(({ GuestResendPasswordDialogController }) => {
      const guestResendPasswordDialog = UdsModalService.createModal({
        controller: GuestResendPasswordDialogController,
        modalName: 'guestResendPasswordDialog',
        data: {}
      })

      guestResendPasswordDialog.open()
    })
  }

  function _getCustomerLogo () {
    const sHost = $location.host()
    AuthService.getCustomerImages(sHost).then(url => {
      $scope.customerLogoPath = url.logo
    })
  }
}

export { EntryController }
